module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-book-webfont.b0afeef9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-book-webfont.svg
// module id = 358
// module chunks = 3